module.exports = __webpack_public_path__ + "static/151812309-wide.c20053de.jpg";